import { Pipe, PipeTransform } from '@angular/core';
import { Nexus } from '@tomandco/nexus-api-types';

@Pipe({
    name: 'searchCountries',
    standalone: true
})
export class SearchCountriesPipe implements PipeTransform {
    transform(countries: Nexus.Lib.General.Country[], value?: string): Nexus.Lib.General.Country[] {
        if (!countries) {
            return [];
        }

        if (!value) {
            return countries;
        }

        value = value.toLowerCase();

        return countries.filter(data => JSON.stringify(data).toLowerCase().includes(value));
    }
}
